import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { ObjectDetailsScreenValidationResult } from '../../../../../../../@types/validation-types'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../common/PopoverContent'

export interface FloorNumberProps extends FieldProps<ObjectDetailsScreenValidationResult> {
  wrapperClassName?: string
  labelTranslationKey?: string
  showMandatory?: boolean
}

export const FloorNumber: React.FC<FloorNumberProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = '',
  labelTranslationKey = 'wizard.screen.objectDetails.floorNumber',
  showMandatory = false,
}) => {
  const { t } = useTranslation()

  const labelWithTooltip = (
    <LabelWithTooltip
      inputId='floor-number'
      labelText={t(labelTranslationKey)}
      tooltipContent={<PopoverContent translationKey='wizard.screen.objectDetails.floorNumber.tooltip' />}
      showMandatory={showMandatory}
      containerClassName='margin-bottom-xs'
    />
  )

  return (
    <div className={wrapperClassName}>
      {labelWithTooltip}
      <Stepper
        id='floor-number'
        propertyName='floor'
        placeholder={t('wizard.screen.objectDetails.placeholder.amount')}
        input={insertionData.floor}
        type='tel'
        min={0}
        max={99}
        step={1}
        errors={validationMessages?.floor ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
